__turbopack_context__.v({
  "arTag": "ArticleList-module-scss-module__-_0WEq__arTag",
  "arTitleText": "ArticleList-module-scss-module__-_0WEq__arTitleText",
  "content": "ArticleList-module-scss-module__-_0WEq__content",
  "imgARTag": "ArticleList-module-scss-module__-_0WEq__imgARTag",
  "imgAuthor": "ArticleList-module-scss-module__-_0WEq__imgAuthor",
  "imgBlur": "ArticleList-module-scss-module__-_0WEq__imgBlur",
  "imgText": "ArticleList-module-scss-module__-_0WEq__imgText",
  "imgWrapper": "ArticleList-module-scss-module__-_0WEq__imgWrapper",
  "listOutline": "ArticleList-module-scss-module__-_0WEq__listOutline",
});
